module.exports = __webpack_public_path__ + "static/img/SignSuccess.94493d5c.png";